<template>
  <div class="d-flex flex-column">
    <span class="text-capitalize-first">
      {{ helper.trans(`antifraudalerts.rule.${alert.rule}`) }}
    </span>
    <div class="text-danger">
      <i class="fa fa-warning"></i> <span class="text-capitalize-first">{{helper.trans(`antifraudalerts.description.${alert.rule}.default`, {currency: data?.currency, sum: numberFormatter.formatNumber(data?.sum, 2), limit: numberFormatter.formatNumber(data?.limit, 2), period: parseInt(data?.period/60)})}}</span>
    </div>
    <div v-if="data?.trafficBlocked" class="text-danger text-capitalize-first">
      <i class="fa fa-warning"></i> <span class="text-capitalize-first d-inline-block">{{ helper.trans('labels.traffic_blocked')}}</span>
    </div>

    <div>
      <i class="fa fa-warning text-danger"></i> <span v-if="data?.disputeOpened" class="text-danger text-capitalize-first d-inline-block">{{ helper.trans(`antifraudalerts.description.${alert.rule}.opened_dispute`) }}</span><span v-else class="text-danger text-capitalize-first d-inline-block">{{ helper.trans(`antifraudalerts.description.${alert.rule}.to_dispute`) }}</span>

      <div class="d-inline-block ms-2" v-for="id in data?.dealsToCheck">
        <span>{{ id }}</span> <copy-button :value="id"></copy-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import {computed, defineComponent, Prop, PropType} from 'vue'
import {helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import AntiFraudAlertDTO from "@/models/AntiFraudAlertDTO";
import PayInCanceledDealsCheckDataDTO from "@/models/AntiFraud/PayInCanceledDealsCheckDataDTO";
import CopyButton from "@/components/CopyButton.vue";

export default defineComponent({
  name: "PayInCanceledDealsCheckDescription",
  components: {CopyButton},
  props: {
    alert: {
      type: Object as PropType<AntiFraudAlertDTO>,
      default: null
    } as Prop<AntiFraudAlertDTO>,
  },
  setup(props) {
    const data = computed((): PayInCanceledDealsCheckDataDTO | null => {
      if (!props.alert) {
        return null
      }

      return props.alert.data as unknown as PayInCanceledDealsCheckDataDTO
    })

    return {
      helper,
      numberFormatter,
      data
    }
  }
})
</script>
